import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./ProductsGallery.scss";
import { ProductsGalleryArray } from "./ProductsGalleryData";
import { FcNext, FcPrevious } from "react-icons/fc";

const Backdrop = ({ setShow }) => {
  return <div className="Backdrop" onClick={() => setShow(false)} />;
};

const Modal = ({ show, image_Array }) => {
  const [activeImageId, setActiveImageID] = useState(3);
  const [imageArray, setImageArray] = useState(image_Array);
  const arrayLength = ProductsGalleryArray.length;

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px";
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "0px";
    };
  }, [show]);

  const activeHandler = (id) => {
    setActiveImageID(id);

    if (id > arrayLength - 2) {
      if (id === arrayLength) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(id - 3),
          ...ProductsGalleryArray.slice(0, 2),
        ]);
      } else if (id === arrayLength - 1) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(id - 3),
          ...ProductsGalleryArray.slice(0, 1),
        ]);
      }
    } else if (id < 3) {
      if (id === 1) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-2),
          ...ProductsGalleryArray.slice(0, 3),
        ]);
      } else if (id === 2) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-1),
          ...ProductsGalleryArray.slice(0, 4),
        ]);
      }
    } else {
      setImageArray(() => ProductsGalleryArray.slice(id - 3, id + 2));
    }
  };

  const activeImagePrevHandler = () => {
    if (activeImageId <= 3) {
      if (activeImageId === 3) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-1),
          ...ProductsGalleryArray.slice(0, 4),
        ]);
      } else if (activeImageId === 2) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-2),
          ...ProductsGalleryArray.slice(0, 3),
        ]);
      } else if (activeImageId === 1) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-3),
          ...ProductsGalleryArray.slice(0, 2),
        ]);
      }
    } else if (activeImageId === arrayLength) {
      setImageArray(() => [
        ...ProductsGalleryArray.slice(-4),
        ...ProductsGalleryArray.slice(0, 1),
      ]);
    } else {
      setImageArray(() =>
        ProductsGalleryArray.slice(activeImageId - 4, activeImageId + 1)
      );
    }

    setActiveImageID((prevId) => {
      if (prevId == 1) {
        return arrayLength;
      } else {
        return prevId - 1;
      }
    });
  };

  const activeImageNextHandler = () => {
    if (activeImageId >= arrayLength - 2) {
      if (activeImageId === arrayLength - 2) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-4),
          ...ProductsGalleryArray.slice(0, 1),
        ]);
      } else if (activeImageId === arrayLength - 1) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-3),
          ...ProductsGalleryArray.slice(0, 2),
        ]);
      } else if (activeImageId === arrayLength) {
        setImageArray(() => [
          ...ProductsGalleryArray.slice(-2),
          ...ProductsGalleryArray.slice(0, 3),
        ]);
      }
    } else if (activeImageId === 1) {
      setImageArray(() => [
        ...ProductsGalleryArray.slice(-1),
        ...ProductsGalleryArray.slice(0, 4),
      ]);
    } else {
      setImageArray(() =>
        ProductsGalleryArray.slice(activeImageId - 2, activeImageId + 3)
      );
    }
    setActiveImageID((prevId) => {
      if (prevId == arrayLength) {
        return 1;
      } else {
        return prevId + 1;
      }
    });
  };

  return (
    <section className="Modal">
      <div>
        <article>
          <img
            src={imageArray[2]?.imageBanner}
            alt={`instrumentImage-${ProductsGalleryArray[0].id}`}
          />
        </article>
        <aside>
          <button onClick={activeImagePrevHandler}>
            <FcPrevious className="grIcon" size={25} />
          </button>
          <button onClick={activeImageNextHandler}>
            <FcNext className="grIcon" size={25} />
          </button>
        </aside>
      </div>
      <div>
        {imageArray?.map((state, index) => {
          return (
            <span key={state.id} className={index === 2 ? "Active_Image" : ""}>
              <img
                src={state.imageSlider}
                alt={`instrument-${state.id}`}
                onClick={() => activeHandler(state.id)}
              />
            </span>
          );
        })}
      </div>
    </section>
  );
};

const ProductsGallery = ({ setShow, show, image_Array }) => {
  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <Backdrop setShow={setShow} />,
        document.getElementById("backdrop-root")
      )}
      {ReactDOM.createPortal(
        <Modal show={show} image_Array={image_Array} />,
        document.getElementById("overlay-root")
      )}
    </React.Fragment>
  );
};

export default ProductsGallery;
